const areas = [
  "Toronto", "Scarborough", "Mississauga", "Brampton", "Markham",
  "Vaughan", "Richmond Hill", "Pickering", "Ajax", "Whitby",
  "Oshawa", "Burlington", "Oakville", "Hamilton", "Barrie",
];

export default function ServiceAreasSection() {
  return (
    <section id="areas" className="w-full bg-white py-28 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="text-stone-400 text-xs uppercase tracking-[0.28em] font-medium block mb-4"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Where We Work
          </span>
          <h2
            className="text-stone-900 font-semibold mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "clamp(2.2rem, 4vw, 3.2rem)" }}
          >
            Serving <span className="font-light italic">Ontario</span>
          </h2>
          <p
            className="text-stone-500 text-base max-w-xl mx-auto leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Taurus Contracting provides deck building, fence installation, and exterior construction services across Ontario — residential and commercial clients welcome.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Left: info + areas */}
          <div>
            {/* SEO keyword tags */}
            <div className="flex flex-wrap gap-2 mb-8">
              {["Deck builder Ontario", "Fence installation Ontario", "Exterior contractor Toronto", "Outdoor structures Ontario", "Deck builder near me"].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 bg-stone-100 text-stone-600 text-xs rounded-sm font-medium whitespace-nowrap"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Cities grid */}
            <div className="grid grid-cols-3 gap-2 mb-8">
              {areas.map((area) => (
                <div
                  key={area}
                  className="flex items-center gap-2 py-2"
                >
                  <span className="w-1 h-1 rounded-full bg-stone-400 flex-shrink-0" />
                  <span
                    className="text-stone-600 text-sm"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {area}
                  </span>
                </div>
              ))}
            </div>

            {/* Address card */}
            <div className="flex items-start gap-4 p-5 bg-stone-50 rounded-sm border border-stone-100">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-stone-900 rounded-sm">
                <i className="ri-map-pin-line text-white text-base"></i>
              </div>
              <div>
                <p
                  className="text-stone-800 font-semibold text-sm mb-1"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  1355 Military Trail, Toronto, ON, M1C 1A3
                </p>
                <a
                  href="tel:4167241172"
                  className="text-stone-500 text-sm hover:text-stone-800 transition-colors"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  (416) 724-1172
                </a>
                <span className="text-stone-300 mx-2">·</span>
                <a
                  href="mailto:info@tauruscontracting.ca"
                  className="text-stone-500 text-sm hover:text-stone-800 transition-colors"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  info@tauruscontracting.ca
                </a>
              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="w-full h-[440px] rounded-sm overflow-hidden border border-stone-100">
            <iframe
              title="Taurus Contracting — 1355 Military Trail, Toronto, ON"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.5!2d-79.1558!3d43.7844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d3e1b1b1b1b1%3A0x1!2s1355+Military+Trail%2C+Toronto%2C+ON+M1C+1A3%2C+Canada!5e0!3m2!1sen!2sca!4v1700000000000!5m2!1sen!2sca"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
